// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5651 ? "web" : chunkId) + "." + {"931":"5b9b6f7e3cfd0fe94159","1700":"53c04cb7925dd5ca9138","2736":"d35b4e88ee82ae3bd6eb","4740":"edd6253db1f991041be8","5651":"d8ce20f015ae495db0ad","9396":"4e3d124344b874967116"}[chunkId] + ".css";
};